import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { ResolveReportModal } from '../components/ResolveReportModal/ResolveReportModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const MODERATION_MODALS = {
  RESOLVE_REPORT: 'moderation.resolve-report',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * **One dialog, not two.** It reads the report *and* decides it, because the two
 * cannot be separated here: the reporter's own words run to 2000 characters, a
 * table cell truncates them, and nobody should record a verdict on a complaint
 * they have only seen the first line of. So the reviewer opens one thing, and
 * what it offers depends on what they hold — the verdict controls are gated
 * inside it on `moderation.manage`, which is the permission the api will
 * actually check (P10.6j: a control's home is decided by its own permission).
 *
 * The queue opens it by **string**, so the list never imports the component that
 * writes a verdict (W2), and the payload is the report **id** alone —
 * `ModalData` is serializable-only and the dialog reads the rest from its own
 * query.
 */
export const moderationModals: readonly ModalRegistration[] = [
  { modalTypes: [MODERATION_MODALS.RESOLVE_REPORT], component: ResolveReportModal },
];
